import { FC, useEffect, useState } from "react";
import "./index.css";
import { usePluginspace } from "../../hooks/usePluginspace";
import api from "../../services/api";
import { FaInstagram, FaFacebook, FaTiktok } from "react-icons/fa";
import { CiGlobe } from "react-icons/ci";

type RedeSocial = {
  id: number;
  name: string;
  url: string;
  type: string;
};

const StoreInfoSocialMedia: FC<{ redeSocial: RedeSocial[] }> = ({
  redeSocial,
}) => {
  const [loading, setLoading] = useState<boolean>(false);
  const { getToken } = usePluginspace();
  function changeIcon(type: string) {
    switch (type) {
      case "TICTOC":
        return <FaTiktok size={18} color={"#3C9EE6"} />;
      case "SITE":
        return <CiGlobe size={21} color={"#3C9EE6"} />;
      case "FACEBOOK":
        return <FaFacebook size={18} color={"#3C9EE6"} />;
      case "INSTAGRAM":
        return <FaInstagram size={18} color={"#3C9EE6"} />;
    }
  }

  function goToSite(url: string) {
    window.open(url, "_blank", "noopener,noreferrer");
  }

  return (
    <div className="info-loja-rede-social">
      {!loading && (
        <>
          {redeSocial.length > 0 && (
            <>
              <h3>Redes Sociais</h3>
              <div className="info-loja-links">
                {redeSocial.map(
                  (rede: RedeSocial) =>
                    rede.type !== "WHATSAPP" && (
                      <div
                        key={rede.type}
                        className="info-loja-link"
                        onClick={() => goToSite(rede.url)}
                      >
                        <div className="icon">{changeIcon(rede.type)}</div>
                        <span>{rede.name}</span>
                      </div>
                    )
                )}
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
};

export { StoreInfoSocialMedia };

const facebookIcon = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.75 8C15.75 11.875 12.9062 15.0938 9.1875 15.6562V10.25H11L11.3438 8H9.1875V6.5625C9.1875 5.9375 9.5 5.34375 10.4688 5.34375H11.4375V3.4375C11.4375 3.4375 10.5625 3.28125 9.6875 3.28125C7.9375 3.28125 6.78125 4.375 6.78125 6.3125V8H4.8125V10.25H6.78125V15.6562C3.0625 15.0938 0.25 11.875 0.25 8C0.25 3.71875 3.71875 0.25 8 0.25C12.2812 0.25 15.75 3.71875 15.75 8Z"
      fill="#3C9EE6"
    />
  </svg>
);

const isntagramIcon = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 3.40625C9.96875 3.40625 11.5938 5.03125 11.5938 7C11.5938 9 9.96875 10.5938 8 10.5938C6 10.5938 4.40625 9 4.40625 7C4.40625 5.03125 6 3.40625 8 3.40625ZM8 9.34375C9.28125 9.34375 10.3125 8.3125 10.3125 7C10.3125 5.71875 9.28125 4.6875 8 4.6875C6.6875 4.6875 5.65625 5.71875 5.65625 7C5.65625 8.3125 6.71875 9.34375 8 9.34375ZM12.5625 3.28125C12.5625 2.8125 12.1875 2.4375 11.7188 2.4375C11.25 2.4375 10.875 2.8125 10.875 3.28125C10.875 3.75 11.25 4.125 11.7188 4.125C12.1875 4.125 12.5625 3.75 12.5625 3.28125ZM14.9375 4.125C15 5.28125 15 8.75 14.9375 9.90625C14.875 11.0312 14.625 12 13.8125 12.8438C13 13.6562 12 13.9062 10.875 13.9688C9.71875 14.0312 6.25 14.0312 5.09375 13.9688C3.96875 13.9062 3 13.6562 2.15625 12.8438C1.34375 12 1.09375 11.0312 1.03125 9.90625C0.96875 8.75 0.96875 5.28125 1.03125 4.125C1.09375 3 1.34375 2 2.15625 1.1875C3 0.375 3.96875 0.125 5.09375 0.0625C6.25 0 9.71875 0 10.875 0.0625C12 0.125 13 0.375 13.8125 1.1875C14.625 2 14.875 3 14.9375 4.125ZM13.4375 11.125C13.8125 10.2188 13.7188 8.03125 13.7188 7C13.7188 6 13.8125 3.8125 13.4375 2.875C13.1875 2.28125 12.7188 1.78125 12.125 1.5625C11.1875 1.1875 9 1.28125 8 1.28125C6.96875 1.28125 4.78125 1.1875 3.875 1.5625C3.25 1.8125 2.78125 2.28125 2.53125 2.875C2.15625 3.8125 2.25 6 2.25 7C2.25 8.03125 2.15625 10.2188 2.53125 11.125C2.78125 11.75 3.25 12.2188 3.875 12.4688C4.78125 12.8438 6.96875 12.75 8 12.75C9 12.75 11.1875 12.8438 12.125 12.4688C12.7188 12.2188 13.2188 11.75 13.4375 11.125Z"
      fill="#3C9EE6"
    />
  </svg>
);

const webSiteIcon = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 14.5C9.21875 14.5 9.84375 14.2812 10.4688 13C10.75 12.4375 11 11.7812 11.1562 11H6.8125C7 11.7812 7.21875 12.4375 7.5 13C8.15625 14.2812 8.75 14.5 9 14.5ZM6.5625 9.5H11.4062C11.4688 9.03125 11.5 8.53125 11.5 8C11.5 7.5 11.4688 7 11.4062 6.5H6.5625C6.5 7 6.5 7.5 6.5 8C6.5 8.53125 6.5 9.03125 6.5625 9.5ZM6.8125 5H11.1562C11 4.25 10.75 3.59375 10.4688 3.03125C9.84375 1.75 9.21875 1.5 9 1.5C8.75 1.5 8.15625 1.75 7.5 3.03125C7.21875 3.59375 7 4.25 6.8125 5ZM12.9062 6.5C12.9688 7 12.9688 7.5 12.9688 8C12.9688 8.53125 12.9688 9.03125 12.9062 9.5H15.3125C15.4375 9.03125 15.5 8.53125 15.5 8C15.5 7.5 15.4375 7 15.3125 6.5H12.9062ZM14.75 5C14.0938 3.71875 13 2.6875 11.6875 2.09375C12.125 2.90625 12.4688 3.90625 12.6875 5H14.75ZM5.28125 5C5.5 3.90625 5.84375 2.90625 6.28125 2.09375C4.96875 2.6875 3.875 3.71875 3.21875 5H5.28125ZM2.65625 6.5C2.5625 7 2.5 7.5 2.5 8C2.5 8.53125 2.53125 9.03125 2.65625 9.5H5.0625C5 9.03125 5 8.53125 5 8C5 7.5 5 7 5.0625 6.5H2.65625ZM11.6875 13.9375C13 13.3438 14.0938 12.3125 14.75 11H12.6875C12.4688 12.125 12.125 13.125 11.6875 13.9375ZM6.28125 13.9375C5.84375 13.125 5.5 12.125 5.28125 11H3.21875C3.875 12.3125 4.96875 13.3438 6.28125 13.9375ZM9 16C6.125 16 3.5 14.5 2.0625 12C0.625 9.53125 0.625 6.5 2.0625 4C3.5 1.53125 6.125 0 9 0C11.8438 0 14.4688 1.53125 15.9062 4C17.3438 6.5 17.3438 9.53125 15.9062 12C14.4688 14.5 11.8438 16 9 16Z"
      fill="#3C9EE6"
    />
  </svg>
);

const tiktokIcon = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 6.5625C13.5938 6.59375 12.2812 6.15625 11.1562 5.34375V10.9375C11.1562 14.8438 6.90625 17.2812 3.53125 15.3438C0.15625 13.375 0.15625 8.5 3.53125 6.53125C4.5 5.96875 5.65625 5.75 6.78125 5.90625V8.71875C5.0625 8.15625 3.40625 9.6875 3.78125 11.4375C4.1875 13.1875 6.3125 13.875 7.65625 12.6562C8.125 12.2188 8.40625 11.5938 8.40625 10.9375V0H11.1562C11.1562 0.25 11.1562 0.46875 11.2188 0.71875C11.4062 1.75 12 2.65625 12.9062 3.21875C13.5 3.625 14.25 3.84375 15 3.84375V6.5625Z"
      fill="#3C9EE6"
    />
  </svg>
);
